import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Box } from "@material-ui/core";

import useTabStyles from "../../styles/Tab.style";
import { PageTitle } from "../../../../components/page-title/PageTitle";
import { RaffleDrawTabPanel } from "../../tab-panels/raffle-draw/RaffleDrawTabPanel";
import { RaffleDrawEntryAttributes } from "../../../../attributes/raffle-draw-entry-attributes.ts";
import RaffleDrawEntryService from "../../../../services/RaffleDrawEntryService";
import RaffleDrawEntry from "../../../../models/RaffleDrawEntry";

interface RaffleDrawTabProps {}

export const RaffleDrawTab = (props: RaffleDrawTabProps) => {
  const tabClasses = useTabStyles(props);
  const intl = useIntl();
  const [raffleDraw, setRaffleDraw] = useState((): any => []);

  const addRaffleDrawCallback = (
    raffleDraw: Array<RaffleDrawEntryAttributes>
  ) => {
    setRaffleDraw(raffleDraw);
  };

  const getAllRaffleDraw = () => {
    RaffleDrawEntryService.getRaffleDraw().then((response) => {
      if (response.isSuccess && response.data.code === 100) {
        let raffleDraw: Array<RaffleDrawEntry> = [];
        const data = JSON.parse(JSON.stringify(response.data.data));
        data.forEach((item, index) => {
          raffleDraw.push(
            RaffleDrawEntry.fromJson(item as RaffleDrawEntryAttributes)
          );
        });
        setRaffleDraw(raffleDraw);
      }
    });
  };

  useEffect(() => {
    getAllRaffleDraw();
  }, []);

  // @ts-ignore
  return (
    <>
      <PageTitle
        withAppTitle={false}
        title={`${intl.formatMessage({
          id: "sharedScreen.admin",
        })} - ${intl.formatMessage({
          id: "sharedScreen.raffleDraw",
        })}`}
      />
      <Box className={tabClasses.root}>
        <RaffleDrawTabPanel closeCallback={() => false} />
      </Box>
    </>
  );
};
